import { Injectable, EventEmitter } from "@angular/core";
import { Observable, BehaviorSubject } from "rxjs/Rx";
import { Response } from "@angular/http";
// Interfaces
import {
	IService,
	IApplicationModel,
	IApplicationsModel,
	IApplicationForm,
	IApplicationCreate,
	IContact,
	IAWSS3,
	IApplication,
	IReviewerModel,
	IReviewersModel,
	IAWSS3Model,
	IStepModel,
	INotify
} from "../../interfaces";
// classes
import {
	ApplicationCreateForm,
	ApplicationForm,
	ApplicationModel,
	ApplicationStatus
} from "../../classes";
// Enums
import { ApplicationStatusEnum, RoleEnum, MessageTypeEnum } from "../../enums";
// Services
import { LogService } from "../log/log.service";
import { ServerService } from "../server/server.service";
import { HelperService } from "../helper/helper.service";
import { ReviewerService } from "../reviewer/reviewer.service";
import { UserService } from "../user/user.service";
import { StorageService } from "../storage/storage.service";
import { LoaderService } from "../loader/loader.service";
import { CmsService } from "../cms/cms.service";
import { ApplicationService } from "../application/application.service";
import { MessageService } from "../message/message.service";

import { FileService } from "../file/file.service";
import { StepService } from "../step/step.service";

import { environment } from "../../../../environments/environment";

@Injectable()
export class ApplicationDownloadService implements IService {
	// implements IService
	name = "ApplicationDownloadService";
	test(name, value) {
		console.log("testing", name, value);
	}

	_isUpgradeSelected: boolean;

	dApplication: IApplication;
	dSteps: IStepModel[];

	constructor(
		private _logSrv: LogService,
		private _helperSrv: HelperService,
		private _cmsSrv: CmsService,
		private _applicationSrv: ApplicationService,
		private _loaderSrv: LoaderService,
		private _msgSrv: MessageService,
		private _userSrv: UserService,
		private _storageSrv: StorageService,
		private _serverSrv: ServerService,
		//CIRCULAR REFERECE ERROR BECAUSE OF THESE 2. Need to move this to share
		private _fileSrv: FileService,
		private _stepSrv: StepService
	) { }

	DownloadApplication(
		appModel: IApplicationModel,
		proceedToMain: boolean = false,
		zipped: boolean = true
	) {
		this._helperSrv.prompt({
			message: this._helperSrv.DOWNLOAD,
			name: "",
			stack: ""
		});

		//let appnumber: string = appModel.Application.ApplicationNumber;
		let appid: string = appModel.Application.Id;

		this._storageSrv.RemoveKey(this._storageSrv.KEY_S3);
		this._loaderSrv.SetLoading(this.name, true);
		// const step = this._stepSrv.DATA.step;
		// let oldValue = this.CONTROL.get('Answer').value;
		// const key = this.CONTROL.get('Key').value;
		const id = this._userSrv.Data.contact.Id;
		console.clear();
		//Get all info abt steps and Questions
		const obs_steps = Observable.fromPromise(this._stepSrv.getSteps(appid));
		//get all info abt the current application (this excludes steps and questions in the api)
		const obs_app = this._applicationSrv.getApplication(id, appid);
		const thiscomponent = this;
		Observable.forkJoin([obs_steps, obs_app]).subscribe(() => {
			this.dApplication =
				thiscomponent._applicationSrv.DATA.application.Application;
			this.dSteps = thiscomponent._stepSrv.DATA.steps.Steps;
			setTimeout(() => {
				//Create the html and post it to S3//Method in turn makes another api call to get a list of all docs and html file and merges it together
				thiscomponent._CreateApplicationHTML_AndPOST(
					appModel,
					proceedToMain,
					zipped
				);
			}, 1500);
		});
	}
	private _CreateApplicationHTML_AndPOST(
		appModel: IApplicationModel,
		proceedToMain: boolean = false,
		zipped: boolean = true
	) {
		const appHtml = this._cmsSrv.CreateApplicationHtml(
			this.dApplication,
			this.dSteps
		);

		//$('#appDetailHTML').html();  //btoa()
		console.clear();
		//console.log(appHtml);
		const file: IAWSS3 = {
			ApplicationNumber: appModel.Application.ApplicationNumber,
			Name: "ApplicationForm",
			Key: undefined,
			LastModified: new Date().toLocaleDateString(),
			Order: 1,
			Url: undefined,
			Type: "text/html",
			Ext: "html"
		};

		// upload file to aws
		this._fileSrv
			.uploadAsync(appHtml, file)
			.then(awss3 => {
				this._logSrv.Debug(this.name, ["file upload", awss3]);
				if (awss3 === undefined) {
					this._msgSrv.DisplayBothError(
						"File has not been uploaded",
						true,
						MessageTypeEnum.ohsnap
					);
				} else {
					//GET ALLL APPLICATIONS
					this._DownloadAppZipFile(
						this._applicationSrv.DATA.application,
						proceedToMain,
						zipped,
						this._isUpgradeSelected
					);
				}
			})
			.catch(err => {
				this._loaderSrv.SetLoading(this.name, false);
				this._logSrv.Error(this.name, [
					"OnUploadClick error save to aws",
					err
				]);
				this._msgSrv.DisplayBothError(
					"File has not been uploaded",
					true,
					MessageTypeEnum.ohsnap
				);
			});
	}

	//Download the merged pdf
	private _DownloadAppZipFile(
		appModel: IApplicationModel,
		proceedToMain: boolean = false,
		zipped: boolean = true,
		isUpgradeAndNotRenewal: boolean = true
	) {
		this._logSrv.Debug(this.name, ["downLoadFile()"]);
		this._loaderSrv.SetLoading(this.name, true);
		const user = this._userSrv.Data.contact;
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_S3);
		const headers = new Headers({
			Authorization: this._helperSrv.Authorization,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/pdf",
			accept: "application/pdf"
		});

		let appnumber: string = appModel.Application.ApplicationNumber;

		const endPoint = `${environment.APIFullPath
			}AWS/S3/get/application/${appnumber}/key/${key}/files/${zipped}`;

		let path = "";

		const finaldoc = this._serverSrv
			.GetWithEndPoint(user.AcepId, endPoint, null)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IAWSS3Model>body.Data;
					path = data.S3.Url;
					return data;
				} else {
					this._logSrv.Error(this.name, ["get file", response]);
					return undefined;
				}
			})
			.toPromise()
			.then(resp => {
				const pathhere = resp.S3.Url;

				this._logSrv.Debug(this.name, ["Response", path]);
				const win = window.open(path, "_blank");
				if (!win || win.closed || win.closed === undefined) {
					alert(
						`Please add ${environment.BaseUrl
						} to your browser's popup blocker exception list`
					);
				}
				this._loaderSrv.SetLoading(this.name, false);

				this._helperSrv.hidePrompt();
				//if procced to main is true ...go to main page...coming from upgrade level button route
				if (proceedToMain) {
					this._helperSrv.goToMainWithLevel(
						appModel.Application.Level, isUpgradeAndNotRenewal
					);
				}
			})
			.catch(err => {
				this._loaderSrv.SetLoading(this.name, false);
				this._logSrv.Error(this.name, [
					"error pulling app from aws",
					err
				]);
			});
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/application.download/application.download.service.ts